<script setup lang="ts">
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-coverflow'
import 'swiper/css/pagination'
import { Swiper, SwiperSlide } from 'swiper/vue'

import DiscussionCard from './DiscussionCard.vue'

defineProps<{ color: string }>()

const { hasWallet } = useLocalStorage()
const activeModules = ref([])

const getDiscussionSliderModules = async () => {
  if (hasWallet.value) {
    activeModules.value.push('wallet')
  }
  activeModules.value.push('survey', 'contest', 'review', 'crm')
}

getDiscussionSliderModules()
</script>

<template>
  <div class="pb-8" :style="{ background: color }">
    <Swiper
      class="pb-10"
      :slides-per-view="1.1"
      :centered-slides="true"
      :space-between="10"
      :pagination="true"
      :autoplay="{
        disableOnInteraction: false,
        delay: 5000
      }"
    >
      <SwiperSlide v-for="module in activeModules" :key="module">
        <DiscussionCard :module="module" :color="color" />
      </SwiperSlide>
    </Swiper>
  </div>
</template>
